// Action Types
export const SET_COMBINATIONS = 'SET_COMBINATIONS';

// Action Creator
export const setCombinations = (combinations) => ({
  type: SET_COMBINATIONS,
  payload: combinations,
});
